import Select from 'react-dropdown-select';
import styled from 'styled-components/macro';
import appTheme from '../../style/themes/appTheme';

export interface StyledDropdownProps {
  error?: boolean;
  searchable?: boolean;
  itemTextColor?: string;
  itemPaddingTop?: string;
  itemPaddingBottom?: string;
}

export const DropdownContainer = styled.div`
  width: 100%;
  outline: none;
`;

export const StyledDropdown = styled(Select) <StyledDropdownProps>`
  min-width: 100%;
  width: 100%;
  min-height: 46px !important;
  color: ${appTheme.palette.label} !important;
  border: ${({ error }) => (error ? appTheme.borderStyles.error : appTheme.borderStyles.primary)};
  border-radius: 4px;
  font-family: ${appTheme.fontFamily.heading};
  .react-dropdown-select-clear,
  .react-dropdown-select-dropdown-handle {}
  .react-dropdown-select-option {
    background-color: ${appTheme.palette.primary};
    margin-left: 40px;
    outline: none;
  }
  .react-dropdown-select-item {}
  .react-dropdown-select-input {
    display: ${({ searchable }) => (searchable ? 'block' : 'none')} !important;
  }
  .react-dropdown-select-dropdown {
    position: absolute;
    left: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    max-height: 300px;
    overflow: auto;
    z-index: 9;
  }
  .react-dropdown-select-item {
    color: ${({ itemTextColor }) => (itemTextColor || appTheme.palette.primary)};
    outline: none;
    padding-top: ${({ itemPaddingTop }) => (itemPaddingTop)};
    padding-bottom: ${({ itemPaddingBottom }) => (itemPaddingBottom)};
   
    :hover {
      color: ${appTheme.palette.white};
      background-color: ${appTheme.palette.primary};
    }
  }
  .react-dropdown-select-item.react-dropdown-select-item-selected,
  .react-dropdown-select-item.react-dropdown-select-item-active {
    font-weight: ${appTheme.fontWeight.bold};
    background-color: ${appTheme.palette.primary};
  }
  .react-dropdown-select-item.react-dropdown-select-item-disabled {
    color: ${appTheme.palette.grey20};
  }
`;
